import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table } from 'antd';
import { 
	getPayrunOTList, doPayrunOTUpdate
} from "../../../../redux/payrun/payrunState";
import { NumberFormatter } from "../../../../utils/index";
import InputSaveOnChange from "components/fields/InputSaveOnChange";

const PayrunOtTable = (props) => {
	
  const { payrunOTList, getPayrunOT, payrunId, payrunIds, mode, updateOTValue } = props;
  
  const doSaveOTValueChanged = (value, record, field, paycodeId) => {
    console.log('doSaveOTValueChanged');
    updateOTValue({'id':record.pot_id, value, field, paycodeId});
  }

  const columns = [
    {
        title: `Date`,
        dataIndex: 'pot_date',
        key: 'pot_date',
        width: 100,
        fixed: 'left',         
    },
    {
        title: `REG OT`,
        dataIndex: 'pot_hours',
        key: 'pot_hours',
        width: 100,
        render: (pot_hours, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pot_hours"
                    paycodeId={4} 
                    mode={mode} 
                    saveValueHandler={doSaveOTValueChanged}
                />
    },
    {
        title: `RD`,
        dataIndex: 'pot_rd',
        key: 'pot_rd',
        width: 100,
        render: (pot_rd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pot_rd" 
                    paycodeId={5} 
                    mode={mode} 
                    saveValueHandler={doSaveOTValueChanged}
                />
    },
    {
        title: `RD OT`,
        dataIndex: 'pot_rd_ot',
        key: 'pot_rd_ot',
        width: 100,
        render: (pot_rd_ot, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pot_rd_ot" 
                    paycodeId={6} 
                    mode={mode} 
                    saveValueHandler={doSaveOTValueChanged}
                />
    },
    {
        title: `RH`,
        dataIndex: 'pot_rh',
        key: 'pot_rh',
        width: 100,
        render: (pot_rh, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pot_rh" 
                    paycodeId={7} 
                    mode={mode} 
                    saveValueHandler={doSaveOTValueChanged}
                />
    },
    {
        title: `RH OT`,
        dataIndex: 'pot_rh_ot',
        key: 'pot_rh_ot',
        width: 100,
        render: (pot_rh_ot, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pot_rh_ot" 
                    paycodeId={8} 
                    mode={mode} 
                    saveValueHandler={doSaveOTValueChanged}
                />
    },    
    {
        title: `RH RD`,
        dataIndex: 'pot_rh_rd',
        key: 'pot_rh_rd',
        width: 100,
        render: (pot_hopot_rh_rdurs, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pot_rh_rd" 
                    paycodeId={9} 
                    mode={mode} 
                    saveValueHandler={doSaveOTValueChanged}
                />
    },
    {
        title: `RH RD OT`,
        dataIndex: 'pot_rh_rd_ot',
        key: 'pot_rh_rd_ot',
        width: 100,
        render: (pot_rh_rd_ot, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pot_rh_rd_ot" 
                    paycodeId={10} 
                    mode={mode} 
                    saveValueHandler={doSaveOTValueChanged}
                />
    },
    {
        title: `SH`,
        dataIndex: 'pot_sh',
        key: 'pot_sh',
        width: 100,
        render: (pot_sh, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pot_sh" 
                    paycodeId={11} 
                    mode={mode} 
                    saveValueHandler={doSaveOTValueChanged}
                />
    },
    {
        title: `SH OT`,
        dataIndex: 'pot_sh_ot',
        key: 'pot_sh_ot',
        width: 100,
        render: (pot_sh_ot, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pot_sh_ot" 
                    paycodeId={12} 
                    mode={mode} 
                    saveValueHandler={doSaveOTValueChanged}
                />
    },
    {
        title: `SH RD`,
        dataIndex: 'pot_sh_rd',
        key: 'pot_sh_rd',
        width: 100,
        render: (pot_sh_rd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pot_sh_rd" 
                    paycodeId={13} 
                    mode={mode} 
                    saveValueHandler={doSaveOTValueChanged}
                />
    },
    {
        title: `SH RD OT`,
        dataIndex: 'pot_sh_rd_ot',
        key: 'pot_sh_rd_ot',
        width: 100,
        render: (pot_sh_rd_ot, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pot_sh_rd_ot" 
                    paycodeId={14} 
                    mode={mode} 
                    saveValueHandler={doSaveOTValueChanged}
                />
    },
    {
        title: `Total OT`,
        dataIndex: 'pot_total_ot_hours',
        key: 'pot_total_ot_hours',
        width: 100,
        fixed: 'right',
        render: (pot_total_ot_hours) => <div>{NumberFormatter(pot_total_ot_hours)}</div>
    },
    ];
	
	useEffect(() => {
	    if (payrunId > 0) {
	        getPayrunOT({payrunId: payrunId, paginate: 0, pivot: 1});
	    }
	}, [getPayrunOT, payrunId]);

    useEffect(() => {
        if (payrunIds) {
            getPayrunOT({payrunIds: payrunIds, paginate: 0});
        }
    }, [getPayrunOT, payrunIds]);
	
  	return (
  		<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
  			<Table
    			dataSource={payrunOTList} 
	        	columns={columns} 
	            rowKey={(record) => record.pot_id}
	            pagination={false}
	            scroll={{
			      x: 1300,
			      y: 420,
			    }}
    		/>
  		</div>
  	);
};

const mapStateToProps = (state) => ({
	payrunOTList: state.payrun.payrunOTList?.items,
});

const mapDispatchToProps = (dispatch) => ({
	getPayrunOT: (id) => dispatch(getPayrunOTList(id)),
    updateOTValue: (data) => dispatch(doPayrunOTUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrunOtTable);